module.exports = __webpack_public_path__ + "img/Xiaofeng_Zhu@2x.d74762f3.png";